import React from 'react';
import { Box, HStack, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

function EmailDetailRow({ title, details }) {
  if (!details) {
    return <div />;
  }

  return (
    <HStack mb={2}>
      <Box justifyContent="flex-end" width="50px">
        <Text textAlign="right">{`${title}:`}</Text>
      </Box>
      <Text>{details}</Text>
    </HStack>
  );
}

EmailDetailRow.propTypes = {
  title: PropTypes.string.isRequired,
  details: PropTypes.string
};

export default EmailDetailRow;
